module.exports = __webpack_public_path__ + "img/cktw3.10330ed6.jpeg";